import { render } from "./TaxPhotoModal.vue?vue&type=template&id=dba96a86&scoped=true"
import script from "./TaxPhotoModal.vue?vue&type=script&lang=js"
export * from "./TaxPhotoModal.vue?vue&type=script&lang=js"

import "./TaxPhotoModal.vue?vue&type=style&index=0&id=dba96a86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba96a86"]])

export default __exports__